import { formatNumber } from '../../core/formatter/formatNumber';
import { getCO2Aequivalent } from '../../main/functions/getCO2Aequivalent';
import { IDs } from '../../helpers/IDs';
import * as React from 'react';
import { SectionStyle } from '../../helpers/SectionStyle';
import { WpdfText } from '../datenauswertung/pdf/WpdfText.';
import { WpdfView } from '../datenauswertung/pdf/WpdfView';

export interface EmissionsfaktorenProps {
    data: any;
    isPdf?: boolean;
    jahr: number;
}

export interface EmissionsfaktorenState {
    data: any;
}

export class Emissionsfaktoren extends React.Component<EmissionsfaktorenProps, EmissionsfaktorenState> {

    constructor(props: any) {
        super(props);
        this.state = {
            data: {}
        };
    }

    private faktoren: Array<any> = [];
    private quellen: any = {};
    private structure: ReadonlyArray<any> = [
        { key: 'benzin', group: 'Brennstoffe' },
        { key: 'diesel', group: 'Brennstoffe' },
        { key: 'hel', group: 'Brennstoffe' },
        { key: 'fluessiggas', group: 'Brennstoffe' },
        { key: 'erdgas', group: 'Brennstoffe' },
        { key: 'steinkohle', group: 'Brennstoffe' },
        { key: 'braunkohle', group: 'Brennstoffe' },
        { key: 'bio_brennholz', group: 'Brennstoffe' },
        { key: 'bio_hackschnitzel', group: 'Brennstoffe' },
        { key: 'bio_holzpellets', group: 'Brennstoffe' },
        { key: 'fernwaerme', group: 'Nah-/Fernwärme' },
        { key: 'fernkaelte', group: 'Nah-/Fernwärme' },
        { key: 'strom', group: 'Strom' },
        { key: 'biodiesel', group: 'Brennstoffe' },
        { key: 'bioethanol', group: 'Brennstoffe' },
        { key: 'biogas', group: 'Brennstoffe' }
    ];

    componentDidMount(): void {
        this.init();
    }

    componentDidUpdate(prevProps: any): void {
        if (this.props.jahr !== prevProps.jahr) {
            this.init();
        }
    }

    getStyle(): any {
        const isPdf: boolean = this.props.isPdf || false;
        const Section: any = new SectionStyle();

        return ({
            main: {
                maxWidth: 655,
                display: 'flex',
                flexDirection: 'column'
            },
            ueberschrift: {
                ...(isPdf ? { fontFamily: 'Helvetica-Bold' } : {}),
                fontSize: '11pt',
                fontWeight: 'bold',
                color: '#555',
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                boxSizing: 'border-box'
            },
            tabelle: {
                fontSize: '9pt',
                marginTop: 15,
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box'
            },
            row: {
                color: '#555',
                backgroundColor: '#ddd',
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                boxSizing: 'border-box'
            },
            row_header: {
                fontWeight: 'bold',
                color: Section.getPropertyValue('--color-button-text') || '#555',
                backgroundColor: Section.getPropertyValue('--color-section-main') || '#bccae3'
            },
            colgroup: {
                display: 'flex',
                flex: 1,
                flexDirection: 'column'
            },
            colgroup_header: {
            },
            col1: {
                flexBasis: '40%'
            },
            col1_header: {
                flexBasis: '80%'
            },
            col2: {
                flexBasis: '40%'
            },
            col2_header: {
                flexBasis: '20%'
            },
            col3: {
                flexBasis: '20%'
            },
            cell: {
                textAlign: 'left',
                padding: isPdf ? 2 : 4,
                borderTop: '1pt solid white',
                borderLeft: '1pt solid white',
                display: 'flex',
                flex: 1,
                justifyContent: 'flex-start',
                boxSizing: 'border-box'
            },
            cell_header: {
            },
            cell1: {
            },
            cell1_header: {
            },
            cell2: {
                flexDirection: 'row'
            },
            cell2_header: {
                textAlign: 'center',
                justifyContent: 'center'
            },
            cell3: {
                textAlign: 'center',
                justifyContent: 'center'
            },
            sub: {
                fontSize: '6pt',
                verticalAlign: 'sub',
                display: 'inline'
            },
            sup: {
                fontSize: '6pt',
                verticalAlign: 'super'
            },
            erlaeuterungen: {
                fontSize: '7.5pt',
                color: '#555',
                marginTop: 5,
                borderLeft: '1pt solid white',
                display: 'flex',
                flexDirection: 'row',
                boxSizing: 'border-box'
            },
            quellen: {
                fontSize: '7.5pt',
                color: '#555',
                marginTop: 5,
                borderLeft: '1pt solid white',
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                boxSizing: 'border-box'
            },
            q_row: {
                display: 'flex',
                flex: 1,
                flexDirection: 'row'
            },
            q_col1: {
                flexBasis: isPdf ? '7.75%' : '9%'
            },
            q_col2: {
                flexBasis: isPdf ? '92.25%' : '91%'
            },
            q_cell: {
                textAlign: 'left',
                padding: 0,
                display: 'flex',
                flex: 1,
                justifyContent: 'flex-start',
                hyphens: 'auto'
            }
        });
    }

    getGruppen(gruppe?: string): any {
        return gruppe
            ? (this.faktoren || []).filter((element: any) => (element.group || null) === gruppe)
            : (this.faktoren || [])
                .filter((element: any, index: any, array: any) => (
                    element.group
                    && array.map((item: any) => item.group).indexOf(element.group) === index
                ))
                .map((item: any) => item.group);
    }

    getQuellen(): any {
        const quellen: any = {};

        (this.props.data[IDs.ENT_QUELLEN] || []).map((item: any) => {
            if (item.tid) {
                quellen[item.tid] = item;
            }
        });

        return quellen;
    }

    init(): void {
        const quellen: any = this.getQuellen() || {};
        let data: any = {};
        let n: number = 0;
        this.faktoren = [...(this.structure || [])];
        this.quellen = {};

        this.faktoren.forEach((item: any, index: number) => {
            const key: string = item.key || null;
            const faktor: any = getCO2Aequivalent(this.props.data, this.props.jahr, key, false) || {};
            const value: number = faktor.wert ? +faktor.wert * 1000000 : null;
            const tid: number = +faktor.quelle_orig || null;
            const beschreibung: number = (quellen[tid] || {}).beschreibung || null;

            if (!value || !item.group) {
                delete this.faktoren[index];
                return;
            }

            if (tid && !this.quellen[tid]) {
                this.quellen[tid] = {
                    beschreibung,
                    kuerzel: ++n
                };
            }
            data = {
                ...data,
                [key]: {
                    name: faktor.name || null,
                    quelle: tid, value
                }
            };
        });
        this.setState({ data });
    }

    render(): JSX.Element {
        if (!this.props.data) {
            return;
        }
        const isPdf: boolean = this.props.isPdf || false;
        const styles: any = this.getStyle();

        return (
            <WpdfView style={styles.main} pdf={isPdf}>
                {this.renderUeberschrift()}
                {this.renderTabelle()}
                {this.renderErlaeuterungen()}
                {this.renderQuellen()}
            </WpdfView>
        );
    }

    renderErlaeuterungen(): JSX.Element {
        const isPdf: boolean = this.props.isPdf || false;
        const styles: any = this.getStyle();

        return (
            <WpdfView style={styles.erlaeuterungen} pdf={isPdf}>
                <WpdfText pdf={isPdf}>
                    =&gt; Für Strom/Fernwärme: Diese Zahlen nur dann nutzen, wenn keine eigenen Emissionswerte a.d. Versorger-Rechnung
                    angegeben sind.
                </WpdfText>
            </WpdfView>
        );
    }

    renderQuellen(): JSX.Element {
        const colBeschreibung: Array<JSX.Element> = [];
        const isPdf: boolean = this.props.isPdf || false;
        const quellen: Array<any> = Object.values(this.quellen || {})
            .sort((a: any, b: any) => (a.kuerzel || 0) < (b.kuerzel || 0) ? -1 : 1) || [];
        const bezeichnung: string = quellen.length > 1 ? 'Quellen:' : 'Quelle:';
        const styles: any = this.getStyle();

        for (const quelle of quellen) {
            const beschreibung: string = quelle.beschreibung || null;
            const kuerzel: number = quelle.kuerzel || null;
            colBeschreibung.push(
                <WpdfView key={`quelle-${kuerzel}`} style={{ ...styles.q_cell, flexDirection: 'row' }} pdf={isPdf}>
                    {kuerzel &&
                        <WpdfView style={{ ...styles.sup, marginRight: 2 }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{kuerzel}</WpdfText>
                        </WpdfView>
                    }
                    <WpdfView style={{ ...(isPdf ? { paddingRight: 5, boxSizing: 'border-box' } : {}) }} pdf={isPdf}>
                        <WpdfText pdf={isPdf}>{beschreibung}</WpdfText>
                    </WpdfView>
                </WpdfView>
            );
        }

        return colBeschreibung.length
            ?
                <WpdfView style={styles.quellen} pdf={isPdf}>
                    <WpdfView style={styles.q_row} pdf={isPdf}>
                        <WpdfView style={{ ...styles.colgroup, ...styles.q_col1 }} pdf={isPdf}>
                            <WpdfView style={styles.q_cell} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>=&gt; {bezeichnung}</WpdfText>
                            </WpdfView>
                        </WpdfView>
                        <WpdfView style={{ ...styles.colgroup, ...styles.q_col2 }} pdf={isPdf}>
                            {colBeschreibung}
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
            : null;
    }

    renderTabelle(): JSX.Element {
        const isPdf: boolean = this.props.isPdf || false;
        const jahr: number = this.props.jahr || null;
        const styles: any = this.getStyle();

        return (
            <WpdfView style={styles.tabelle} pdf={isPdf}>
                <WpdfView style={{ ...styles.row, ...styles.row_header }} pdf={isPdf}>
                    <WpdfView style={{ ...styles.colgroup, ...styles.colgroup_header, ...styles.col1_header }} pdf={isPdf}>
                        <WpdfView
                            style={{ ...styles.cell, ...styles.cell_header, ...styles.cell1_header, borderTop: 0, borderLeft: 0 }}
                            pdf={isPdf}
                        >
                            <WpdfText style={{ margin: 'auto', marginLeft: 0 }} pdf={isPdf}>
                                Energieträger {jahr} (Werte siehe Quellenangabe)
                            </WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.colgroup_header, ...styles.col2_header }} pdf={isPdf}>
                        <WpdfView
                            style={{ ...styles.cell, ...styles.cell_header, ...styles.cell2_header, borderTop: 0 }}
                            pdf={isPdf}
                        >
                            <WpdfText pdf={isPdf}>
                                Emissionsfaktoren{!isPdf && <br />}{'\n'}g CO
                                <WpdfText style={styles.sub} pdf={isPdf}>2</WpdfText> / kWh
                            </WpdfText>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
                {this.renderTabelleGruppen()}
            </WpdfView>
        );
    }

    renderTabelleEnergietraeger(gruppe: string): Array<JSX.Element> {
        const colEmissionsfaktor: Array<JSX.Element> = [];
        const colEnergietraeger: Array<JSX.Element> = [];
        const data: any = this.state.data || {};
        const energietraeger: Array<any> = this.getGruppen(gruppe) || [];
        const isPdf: boolean = this.props.isPdf || false;
        const styles: any = this.getStyle();

        for (const item of energietraeger) {
            const key: string = item.key || null;
            const param: any = data[key] || {};
            const name: string = param.name || null;
            const kuerzel: number = +(this.quellen[param.quelle || null] || {}).kuerzel || null;
            const value: number = +param.value || null;
            colEnergietraeger.push(
                <WpdfView key={`energietraeger-${key}`} style={{ ...styles.cell, ...styles.cell2 }} pdf={isPdf}>
                    <WpdfView pdf={isPdf}><WpdfText pdf={isPdf}>{name}</WpdfText></WpdfView>
                    {kuerzel &&
                        <WpdfView style={{ ...styles.sup, marginLeft: 2 }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{kuerzel}</WpdfText>
                        </WpdfView>
                    }
                </WpdfView>
            );
            colEmissionsfaktor.push(
                <WpdfView key={`emissionsfaktor-${key}`} style={{ ...styles.cell, ...styles.cell3 }} pdf={isPdf}>
                    <WpdfText pdf={isPdf}>{formatNumber(value, 0)}</WpdfText>
                </WpdfView>
            );
        }

        return [
            <WpdfView key='energietraeger' style={{ ...styles.colgroup, ...styles.col2 }} pdf={isPdf}>
                {colEnergietraeger}
            </WpdfView>,
            <WpdfView key='emissionsfaktor' style={{ ...styles.colgroup, ...styles.col3 }} pdf={isPdf}>
                {colEmissionsfaktor}
            </WpdfView>
        ];
    }

    renderTabelleGruppen(): Array<JSX.Element> {
        const gruppen: Array<string> = this.getGruppen() || [];
        const isPdf: boolean = this.props.isPdf || false;
        const rows: Array<any> = [];
        const styles: any = this.getStyle();

        gruppen.forEach((gruppe: any, key: number) => {
            const energietraeger: Array<any> = this.getGruppen(gruppe) || [];

            if (!energietraeger.length) {
                return;
            }
            rows.push(
                <WpdfView key={`gruppe-${key}`} style={styles.row} pdf={isPdf}>
                    <WpdfView style={{ ...styles.colgroup, ...styles.col1 }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell1, borderLeft: 0 }} pdf={isPdf}>
                            <WpdfText style={{ margin: 'auto', marginLeft: 0 }} pdf={isPdf}>{gruppe}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    {this.renderTabelleEnergietraeger(gruppe)}
                </WpdfView>
            );
        });

        return rows;
    }

    renderUeberschrift(): JSX.Element {
        const isPdf: boolean = this.props.isPdf || false;
        const styles: any = this.getStyle();

        return (
            <WpdfView style={styles.ueberschrift} pdf={isPdf}>
                <WpdfText pdf={isPdf}>
                    I) CO<WpdfText style={styles.sub} pdf={isPdf}>2</WpdfText>-Emissionsfaktoren, Brennstoffbezogene Emissionsfaktoren
                </WpdfText>
            </WpdfView>
        );
    }
}
